import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useReveal } from "@/hooks/useReveal";
import { useContent } from "@/context/ContentContext";

/**
 * Trumpas filosofijos blokas pagrindiniame puslapyje.
 */
export default function HomePhilosophy() {
  const { content } = useContent();
  const hp = content.homePhilosophy || {};
  const stats = hp.stats || [];
  const r1 = useReveal();
  const r2 = useReveal();
  return (
    <section
      data-testid="home-philosophy"
      className="bg-[#f9f8f6] py-24 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20">
        <div className="md:col-span-5 reveal" ref={r1}>
          <span className="overline">— Filosofija</span>
          <h2 className="mt-6 font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#1a1a1a]">
            {hp.headlineTop || "Kuriu erdves"}
            <br />
            <span className="italic">{hp.headlineBottom || "poilsiui"}</span>
          </h2>
        </div>
        <div className="md:col-span-7 reveal" ref={r2}>
          <div className="space-y-6 text-[#3a3a3a] text-base md:text-lg leading-relaxed font-light max-w-2xl">
            {(hp.paragraphs || []).map((p, i, arr) => (
              <p key={i} className={i === arr.length - 1 ? "text-[#1a1a1a]" : ""}>
                {p}
              </p>
            ))}
          </div>

          {stats.length > 0 && (
            <div className="mt-12 grid grid-cols-3 gap-6 max-w-lg">
              {stats.slice(0, 3).map((s) => (
                <Stat key={s.label} n={s.n} label={s.label} />
              ))}
            </div>
          )}

          <div className="mt-12">
            <Link
              to={hp.ctaTo || "/autorius"}
              data-testid="home-philosophy-cta"
              className="inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.22em] text-[#1a1a1a] border-b border-[#1a1a1a] pb-1 hover:text-[#a66e4b] hover:border-[#a66e4b] transition-colors"
            >
              {hp.ctaLabel || "Apie mane"} <ArrowRight size={14} strokeWidth={1.5} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ n, label }) {
  return (
    <div>
      <div className="font-serif-display text-3xl md:text-4xl text-[#1a1a1a]">
        {n}
      </div>
      <div className="overline mt-2">{label}</div>
    </div>
  );
}
